"use strict";
/**
 * @module RPC-API-Methods
 * copyright defined in eosjs/LICENSE.txt
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=eosjs-rpc-interfaces.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ual-scatter/node_modules/eosjs/dist/eosjs-rpc-interfaces.js
// module id = bJdx
// module chunks = 1